module.exports = __webpack_public_path__ + "static/media/RP-36.6ce795b6.pdf";